import React from 'react';
import { CONTACT_EMAIL, ADDRESS, FACEBOOK_URL } from '../constants/contact';

const PageFooter = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 relative z-10">
      <div className="glass-section">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-white mb-8">

          {/* Brand */}
          <div className="text-center sm:text-left">
            <h3 className="font-display text-lg font-semibold mb-3">
              Therapeutic Riding at Normandy Farm
            </h3>
            <p className="text-white/60 text-sm leading-relaxed">
              Empowering lives through the healing power of horses since 1992.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold text-white/90 mb-3 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><a href="#about" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#volunteer" className="hover:text-white transition-colors">Volunteer</a></li>
              <li><a href="#events" className="hover:text-white transition-colors">Upcoming Events</a></li>
              <li><a href="#donations" className="hover:text-white transition-colors">Donations</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold text-white/90 mb-3 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-1.5 text-sm text-white/60">
              <p>{ADDRESS}</p>
              <p>Harford County, Maryland</p>
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white transition-colors block mt-2">
                {CONTACT_EMAIL}
              </a>
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors flex items-center justify-center sm:justify-start gap-2 mt-2"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
                </svg>
                Facebook
              </a>
            </div>
          </div>

        </div>

        <div className="border-t border-white/20 pt-6 text-center">
          <p className="text-xs text-white/50">
            Copyright &copy; {new Date().getFullYear()} Therapeutic Riding at Normandy Farm. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageFooter;
